module.exports = __webpack_public_path__ + "img/ic_broken.7a9e9b4c.png";